export const DEFAULT = 'DEFAULT'
export const MODERATION = 'MODERATION'
export const SUCCESS = 'SUCCESS'
export const ERROR = 'ERROR'
export const NOT_SAVED = 'NOT_SAVED'
